<template>
  <div class="w-full">
    <Image
      :src="banner"
      alt=""
      class="mb-3"
      @click="$router.push(`/agentrule?activityId=${activityId}`)"
    />
    <ShareLink />
    <div class="text-white text-[15px] font-[500] mt-4">
      {{ $t("Activities.Agentcenter.ShareLink") }}
    </div>
    <TableList :title="$t('Activities.Agentcenter.MyEarnings')" :leftIcon="meiyuan_bai">
      <template #right>
        <RightChildren
          :text="$t('Activities.Agentcenter.ViewDetails')"
          @click="
            () => {
              if (!useUserInfo().isLoggedin) {
                showLoginOrReg();
                return;
              }
              $router.push('/agentdetail');
            }
          "
        />
      </template>
      <GanhosContent
        :agentInfoMeusGanhos="agentInfoMeusGanhos"
        @update="queryAgentUserInfo"
      />
    </TableList>

    <TableList
      :title="$t('Activities.Agentcenter.YesterdaySummary')"
      :leftIcon="yuce_bai"
    >
      <template #right>
        <RightChildren
          :text="$t('Common.More')"
          @click="
            () => {
              if (!useUserInfo().isLoggedin) {
                showLoginOrReg();
                return;
              }
              $router.push('/income');
            }
          "
        />
      </template>
      <ResumoContent />
    </TableList>

    <TableList :title="$t('Activities.Agentcenter.MyTeam')" :leftIcon="threeUser">
      <template #right>
        <RightChildren
          :text="$t('Common.More')"
          @click="
            () => {
              if (!useUserInfo().isLoggedin) {
                showLoginOrReg();
                return;
              }
              $router.push('/income?agentLevel=All');
            }
          "
        />
      </template>
      <TimeContent :myTeam="myTeam" />
    </TableList>
    <ActivityDesc
      class="mt-4"
      :title="$t('Activities.Agentcenter.ActivityDescription')"
      :list="activityDetail.descList || []"
    />
  </div>
</template>

<script setup lang="ts">
import banner from "./images/banner.png";
import { useUserInfo } from "@/store";
import showLoginOrReg from "@a/components/showLoginOrRegPopup";
import ShareLink from "@a/components/ShareLink/index.vue";
import RightChildren from "./components/RightChildren.vue";
import TableList from "./components/TableList.vue";
import meiyuan_bai from "./images/meiyuan_bai.png";
import yuce_bai from "./images/yuce_bai.png";
import threeUser from "./images/threeUser.png";
import { getAgentUserInfo } from "@/api/agent";
import GanhosContent from "./components/GanhosContent.vue";
import ResumoContent from "./components/ResumoContent.vue";
import TimeContent from "./components/TimeContent.vue";
import ActivityDesc from "@/components/ActivityDesc/index.vue";
import { getActivityDetail } from "@/api/activity";
import { useRoute } from "vue-router";
const activityId: any = useRoute().query.activityId || "";
const activityDetail = ref<any>({});
const getActivityDetailData = async () => {
  const res = await getActivityDetail({ activityId });
  if (res.code === 1) {
    const descList = res.data.activityConfigDesc.split("\n") || [];
    activityDetail.value = { ...res.data, descList };
  }
};
// 代理团队信息
const agentInfoMeusGanhos = ref<any>({
  teamTotalDeposit: "0.00",
  teamDepositAgentAmount: "0.00",
  teamTotalBet: "0.00",
  teamBetAgentAmount: "0.00",
  receivedAgentAmount: "0.00",
  availableAgentAmount: "0.00",
  firstLowerAgentNum: "0",
  secondLowerAgentNum: "0",
  thirdLowerAgentNum: "0",
  firstContributionCommission: "0.00",
  secondContributionCommission: "0.00",
  thirdContributionCommission: "0.00",
});
// 代理团队信息
const myTeam = ref<any>([]);

// 查询代理用户信息
const queryAgentUserInfo = async () => {
  let { code, data } = await getAgentUserInfo();
  if (code === 1) {
    agentInfoMeusGanhos.value = data;
  }

  agentInfoMeusGanhos.value = data;

  myTeam.value = [
    {
      agentLevel: 1,
      agentNum: data.firstLowerAgentNum,
      amount: data.firstContributionCommission,
    },
    {
      agentLevel: 2,
      agentNum: data.secondLowerAgentNum,
      amount: data.secondContributionCommission,
    },
    {
      agentLevel: 3,
      agentNum: data.thirdLowerAgentNum,
      amount: data.thirdContributionCommission,
    },
  ];
};

onMounted(() => {
  queryAgentUserInfo();
  getActivityDetailData();
});
</script>
